/**
 * Carga diferida del segmentador: scripts y catálogo solo cuando hace falta.
 */
(function () {
  'use strict';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function parseCatalogFromSectionHtml(html) {
    if (!html) return [];
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.getElementById('oleum-product-catalog');
      if (!el || !el.textContent) return [];
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[Oleum] No se pudo parsear el catálogo:', e);
      return [];
    }
  }

  function loadCatalog() {
    if (window.OleumProductCatalog && window.OleumProductCatalog.length) {
      return Promise.resolve(window.OleumProductCatalog);
    }
    if (window.__oleumCatalogPromise) return window.__oleumCatalogPromise;

    var root =
      (typeof window.Shopify !== 'undefined' &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    window.__oleumCatalogPromise = fetch(root + '?sections=oleum-product-catalog', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('catalog section ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var catalog = parseCatalogFromSectionHtml(data['oleum-product-catalog'] || '');
        window.OleumProductCatalog = catalog;
        return catalog;
      })
      .catch(function () {
        window.OleumProductCatalog = window.OleumProductCatalog || [];
        return window.OleumProductCatalog;
      });

    return window.__oleumCatalogPromise;
  }

  function loadSegmentadorBundle() {
    if (window.__oleumSegmentadorBundle) return window.__oleumSegmentadorBundle;
    var assets = window.OleumSegmentadorAssets || {};
    window.__oleumSegmentadorBundle = loadScript(assets.analytics)
      .then(function () {
        return loadScript(assets.engine);
      })
      .then(function () {
        return loadScript(assets.recommender);
      })
      .then(function () {
        return loadScript(assets.segmentador);
      });
    return window.__oleumSegmentadorBundle;
  }

  function openSegmentador() {
    return loadSegmentadorBundle()
      .then(function () {
        if (window.OleumProfileEngine && typeof window.OleumProfileEngine.captureBrowseCollection === 'function') {
          window.OleumProfileEngine.captureBrowseCollection();
        }
        loadCatalog();
        if (typeof window.OleumSegmentadorOpen === 'function') {
          window.OleumSegmentadorOpen();
          return;
        }
        if (typeof window.OleumQuizOpen === 'function') {
          window.OleumQuizOpen();
        }
      })
      .catch(function (err) {
        console.warn('[Oleum] Segmentador no disponible:', err);
      });
  }

  window.OleumLoadCatalog = loadCatalog;

  function bindQuizTriggers() {
    if (window.__oleumSegmentadorBootBound) return;
    window.__oleumSegmentadorBootBound = true;

    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('[data-oleum-quiz-open]');
      if (!el) return;
      e.preventDefault();
      openSegmentador();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuizTriggers);
  } else {
    bindQuizTriggers();
  }
})();
